import React from 'react'
import { amtNumStr } from '@ifca-root/react-component/src/helpers/StringNumberFunction/numFormatter'
import { useMenuOption } from 'helpers/Hooks/useMenuOption'
import { formatDate } from 'helpers/StringNumberFunction/FormatDate'
import { useState } from 'react'
import { useHistory, useParams } from 'react-router'

interface DetailProps {
  listEl: any
  listStatus: string
  userList: any
  documentListing?: any
  mode?: string
}

export const ProvisionImpairmentDetailContent = (props: DetailProps) => {
  const history = useHistory()
  const { CompanyID }: any = useParams()
  const { listEl, documentListing, listStatus, userList, mode } = props
  const [openDoc, setOpenDoc] = useState<boolean>(false)
  const { menu } = useMenuOption()

  return (
    <>
      <div className="content-wrap left">
        <div className="desc" style={{ color: 'grey' }}>
          Start Date
        </div>
        <div className="mdDesc text-noflow">
          {formatDate(listEl?.StartDate)}
        </div>
      </div>
      <div className="content-wrap right">
        <div className="desc" style={{ color: 'grey' }}>
          Model No.
        </div>
        <div className="mdDesc text-noflow">{listEl?.ModelNo}</div>
      </div>
      <div className="content-wrap left">
        <div className="desc" style={{ color: 'grey' }}>
          Original Amount
        </div>
        <div className="mdDesc text-noflow">
          {amtNumStr(listEl?.OriginalAmount)}
        </div>
      </div>
      <div className="content-wrap right">
        <div className="desc" style={{ color: 'grey' }}>
          Quantity
        </div>
        <div className="mdDesc text-noflow">{listEl?.Quantity}</div>
      </div>
      <div className="content-wrap left">
        <div className="desc" style={{ color: 'grey' }}>
          Acc. Depreciated Amount
        </div>
        <div className="mdDesc text-noflow">
          {amtNumStr(listEl?.AccDepreciatedAmount)}
        </div>
      </div>
      <div className="content-wrap right">
        <div className="desc" style={{ color: 'grey' }}>
          Accumulated Impairment
        </div>
        <div className="mdDesc text-noflow">
          {amtNumStr(listEl?.AccumulatedImpairAmount)}
        </div>
      </div>
      <div className="content-wrap left">
        <div className="desc" style={{ color: 'grey' }}>
          Acc. Impairment Reversal
        </div>
        <div className="mdDesc text-noflow">
          {amtNumStr(listEl?.AccImpairReversal)}
        </div>
      </div>
      <div className="content-wrap right">
        <div className="desc" style={{ color: 'grey' }}>
          Residual Value
        </div>
        <div className="mdDesc text-noflow">
          {amtNumStr(listEl?.ResidualValue)}
        </div>
      </div>
      <div className="content-wrap full">
        <div className="desc" style={{ color: 'grey' }}>
          Residual (%)
        </div>
        <div className="mdDesc text-noflow">
          {amtNumStr(listEl?.ResidualPercent)}
        </div>
      </div>
    </>
  )
}
